import { render } from "./LoyaltyRedemptionsReportView.vue?vue&type=template&id=a72bb010&scoped=true"
import script from "./LoyaltyRedemptionsReportView.vue?vue&type=script&lang=js"
export * from "./LoyaltyRedemptionsReportView.vue?vue&type=script&lang=js"

import "./LoyaltyRedemptionsReportView.vue?vue&type=style&index=0&id=a72bb010&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a72bb010"]])

export default __exports__